import React from 'react';
import { useTranslation } from 'react-i18next';
import ActiveShipmentsTable from '../../components/shipment-tracker/ActiveShipmentsTable';

const ShipmentTrackerShipmentsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="page shipment-tracker-shipments-page">
      <h1>{t('sidebar_shipment_tracker_shipments')}</h1>
      <ActiveShipmentsTable showCsvButton />
    </div>
  );
};

export default ShipmentTrackerShipmentsPage;
